import React,{useEffect} from 'react'
import Notification from "./Notification" 
const NotificationSlide = (props) => {
    const {REACT_APP_IMAGEURL} = window.weeksWebCloudConfig;
    useEffect(() => {
     
    }, [props]);
    return (
        <div className={`slide-menu-container ${props.slideNotification && props.mobileMenuState === "NOTIFICATION" ? "slide-in":"slide-out"}`}>
            <div className="col-12 border-bottom">
                <a className="points-x-small bold py-3 d-block black-link-color" href="#!"  onClick={props.backNavFunc}><img src={`${REACT_APP_IMAGEURL}/static/images/rebrand-ds/Arrow-left.png`} width="24px" height="24px"/>{props.$mainMenuLinkTxt}</a>
            </div>
           <Notification/> 
        </div>
    )
}

export default NotificationSlide;
